<div class="centered-overlay">
    <div class="welcome">
        <div class="loader xl"></div>
        <div class="welcome-text">
            Please, hold on a few seconds while we're loading your profile
        </div>
    </div>
</div>
